import { ShipmentStatusMappingContainer } from './components/containers/ShipmentStatusMappingContainer';

export const ShipmentStatusMapping = () => {
  return <ShipmentStatusMappingContainer />;
};
